
define('template!adminWorkActivityListTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="admin-work-activity">\n  ';
 if (!canView) { ;
__p += '\n    <div class="not-authorized">\n      <i class="fa fa-lock"></i>\n      <p>' +
((__t = ( _.i18n('admin.workActivity.notAuthorized', null, 'You are not authorized to view this page.') )) == null ? '' : __t) +
'</p>\n    </div>\n  ';
 } else { ;
__p += '\n\n  <header class="page-header">\n    <h2><i class="fa fa-clock-o"></i> ' +
((__t = ( _.i18n('admin.workActivity.title', null, 'Work activity') )) == null ? '' : __t) +
'</h2>\n    <div class="filters">\n      <div class="presets">\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === 'today' ? 'active' : '' ) +
'" data-preset="today">' +
((__t = ( _.i18n('admin.workActivity.today', null, 'Today') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '7d' ? 'active' : '' ) +
'" data-preset="7d">' +
((__t = ( _.i18n('admin.workActivity.last7d', null, 'Last 7 days') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '30d' ? 'active' : '' ) +
'" data-preset="30d">' +
((__t = ( _.i18n('admin.workActivity.last30d', null, 'Last 30 days') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === 'month' ? 'active' : '' ) +
'" data-preset="month">' +
((__t = ( _.i18n('admin.workActivity.thisMonth', null, 'This month') )) == null ? '' : __t) +
'</button>\n      </div>\n      <div class="range">\n        <input type="date" class="js-from" value="' +
__e( fromValue ) +
'" aria-label="From" />\n        <span class="dash">&mdash;</span>\n        <input type="date" class="js-to" value="' +
__e( toValue ) +
'" aria-label="To" />\n        <button type="button" class="btn btn-primary js-apply">' +
((__t = ( _.i18n('common.apply', null, 'Apply') )) == null ? '' : __t) +
'</button>\n      </div>\n    </div>\n  </header>\n\n  <section class="kpis">\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.totalHours ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.kpi.totalHours', null, 'Total hours') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.activeUsers ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.kpi.activeUsers', null, 'Active users') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.avgHoursPerUser ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.workActivity.kpi.avgHoursPerUser', null, 'Avg hours / user') )) == null ? '' : __t) +
'</div>\n    </div>\n  </section>\n\n  <section class="main-grid">\n\n    <div class="panel people-panel">\n      <header class="panel-header">\n        <h3><i class="fa fa-users"></i> ' +
((__t = ( _.i18n('admin.workActivity.people', null, 'People') )) == null ? '' : __t) +
'</h3>\n        <span class="panel-hint">' +
((__t = ( _.i18n('admin.workActivity.clickRowHint', null, 'Click a user for details') )) == null ? '' : __t) +
'</span>\n      </header>\n      ';
 if (rows.length === 0) { ;
__p += '\n        <div class="empty">' +
((__t = ( _.i18n('admin.workActivity.noData', null, 'No data for this period') )) == null ? '' : __t) +
'</div>\n      ';
 } else { ;
__p += '\n      <table class="people-table">\n        <thead>\n          <tr>\n            <th class="rank">#</th>\n            <th>' +
((__t = ( _.i18n('admin.workActivity.user', null, 'User') )) == null ? '' : __t) +
'</th>\n            <th class="num">' +
((__t = ( _.i18n('admin.workActivity.hours', null, 'Hours') )) == null ? '' : __t) +
'</th>\n            <th class="bar-col">' +
((__t = ( _.i18n('admin.workActivity.share', null, 'Share') )) == null ? '' : __t) +
'</th>\n            <th class="num">' +
((__t = ( _.i18n('admin.workActivity.activeDays', null, 'Active days') )) == null ? '' : __t) +
'</th>\n            <th>' +
((__t = ( _.i18n('admin.workActivity.lastSeen', null, 'Last seen') )) == null ? '' : __t) +
'</th>\n          </tr>\n        </thead>\n        <tbody class="js-rows">\n        ';
 _.each(rows, function (row, idx) { ;
__p += '\n          <tr class="js-row ' +
__e( row.userpidSecId === selectedUserSecId ? 'selected' : '' ) +
'" data-userpid-sec-id="' +
__e( row.userpidSecId ) +
'">\n            <td class="rank">' +
__e( idx + 1 ) +
'</td>\n            <td>\n              <div class="user-cell">\n                <span class="user-avatar">' +
__e( row.initials ) +
'</span>\n                <div class="user-meta">\n                  <span class="user-name">' +
__e( row.fullName ) +
'</span>\n                  <span class="user-handle">' +
__e( row.handle ) +
'</span>\n                </div>\n              </div>\n            </td>\n            <td class="num"><strong>' +
__e( row.totalHours ) +
'</strong></td>\n            <td class="bar-col">\n              <div class="bar-track">\n                <div class="bar-fill" style="width: ' +
__e( row.barPct ) +
'%"></div>\n              </div>\n            </td>\n            <td class="num">' +
__e( row.activeDays ) +
'</td>\n            <td class="rel-time" title="' +
__e( row.lastSeenFull ) +
'">' +
__e( row.lastSeenLabel ) +
'</td>\n          </tr>\n        ';
 }); ;
__p += '\n        </tbody>\n      </table>\n      ';
 } ;
__p += '\n    </div>\n\n    <div class="panel activity-panel">\n      <header class="panel-header">\n        <h3><i class="fa fa-exchange"></i> ' +
((__t = ( _.i18n('admin.workActivity.topMovers', null, 'Top movers') )) == null ? '' : __t) +
'</h3>\n        <span class="panel-hint">' +
((__t = ( _.i18n('admin.workActivity.topMoversHint', null, 'Top users per status code') )) == null ? '' : __t) +
'</span>\n      </header>\n      <div class="js-top-movers top-movers">\n        ';
 if (topMoversGroups.length === 0) { ;
__p += '\n          <div class="empty">' +
((__t = ( _.i18n('admin.workActivity.noActivity', null, 'No activity') )) == null ? '' : __t) +
'</div>\n        ';
 } ;
__p += '\n        ';
 _.each(topMoversGroups, function (group) { ;
__p += '\n          <div class="mover-group">\n            <div class="mover-group-header">\n              ';
 if (group.commandType) { ;
__p += '\n                <span class="badge cmd-' +
__e( group.commandTypeClass ) +
'">' +
__e( group.commandType ) +
'</span>\n              ';
 } ;
__p += '\n              <span class="status-label">' +
__e( group.status ) +
'</span>\n            </div>\n            <ol class="mover-list">\n              ';
 _.each(group.movers, function (mover, i) { ;
__p += '\n                <li>\n                  <span class="mv-rank">' +
__e( i + 1 ) +
'</span>\n                  <span class="mv-name">' +
__e( mover.firstName ) +
' ' +
__e( mover.lastName ) +
'</span>\n                  <span class="mv-count">' +
__e( mover.count ) +
'</span>\n                </li>\n              ';
 }); ;
__p += '\n              ';
 if (group.movers.length === 0) { ;
__p += '\n                <li class="empty-row">' +
((__t = ( _.i18n('admin.workActivity.noActivity', null, 'No activity') )) == null ? '' : __t) +
'</li>\n              ';
 } ;
__p += '\n            </ol>\n          </div>\n        ';
 }); ;
__p += '\n      </div>\n    </div>\n\n  </section>\n\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

